// Generated at build time by scripts/render-runtime-config.mjs.
globalThis.__QEP_RUNTIME_CONFIG__ = Object.freeze({
    "API_SERVER": "https://wgw.uat.qep.trade",
    "FILESERVER": "https://uat.qep.trade",
    "WEBSOCKETSERVER": "wss://wgw.uat.qep.trade/ws",
    "MDS_WS_SERVER": "wss://mds.uat.qep.trade/v1/ws",
    "OAS_WS_SERVER": "wss://oas.uat.qep.trade/v1/ws",
    "AUTHCLIENTID": "e70c9e2b-f6f5-4172-a62f-ee986fdb2294",
    "AUTHREDIRECT": "https://wgw.uat.qep.trade/auth/callback",
    "AUTHSTATE": "staging",
    "APP_ENV": "staging",
    "PREVIEW_MODE": "",
    "SUBSCRIPTION_PAYLOAD_LOG_MODE": "summary",
    "WORKSPACE_TAB_RENDER_ON_DEMAND": "false"
});

//# sourceMappingURL=AuthFail.958d710a.js.map
